import React, { useState, useEffect } from 'react';

const names = ['Rajesh', 'Priya', 'Kumar', 'Lakshmi', 'Anand', 'Meena', 'Suresh', 'Deepa', 'Vijay', 'Saranya', 'Ravi', 'Divya'];
const locations = ['Mylapore', 'Triplicane', 'Royapettah', 'T. Nagar', 'Chepauk', 'Mandaveli', 'Alwarpet', 'Egmore'];
const departments = ['Gynaecology', 'Cardiology', 'Urology', 'Orthopaedics', 'ENT', 'Paediatrics', 'General Check-up'];
const actions = ['booked an appointment', 'booked a consultation', 'scheduled a check-up'];

const SocialProofToast = () => {
  const [notification, setNotification] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const showNotification = () => {
      const name = names[Math.floor(Math.random() * names.length)];
      const loc = locations[Math.floor(Math.random() * locations.length)];
      const dept = departments[Math.floor(Math.random() * departments.length)];
      const action = actions[Math.floor(Math.random() * actions.length)];
      const mins = Math.floor(Math.random() * 15) + 1;
      setNotification({ name, loc, dept, action, mins });
      setShow(true);
      setTimeout(() => setShow(false), 4000);
    };

    // First notification after 15 seconds
    const firstTimer = setTimeout(showNotification, 15000);
    // Then every 25-40 seconds
    const interval = setInterval(showNotification, 25000 + Math.random() * 15000);
    return () => { clearTimeout(firstTimer); clearInterval(interval); };
  }, []);

  if (!show || !notification) return null;

  return (
    <div
      className="fixed bottom-28 left-6 z-40 animate-slide-in-left"
      data-testid="social-proof-toast"
    >
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 px-4 py-3 flex items-center gap-3 max-w-xs">
        <div className="w-9 h-9 rounded-full bg-[#0066b3]/10 flex items-center justify-center flex-shrink-0">
          <span className="text-sm font-bold text-[#0066b3]">{notification.name[0]}</span>
        </div>
        <div>
          <p className="text-xs text-[#0f172a]">
            <span className="font-semibold">{notification.name}</span> from {notification.loc} {notification.action} for <span className="font-semibold text-[#0066b3]">{notification.dept}</span>
          </p>
          <p className="text-[10px] text-[#94a3b8] mt-0.5">{notification.mins} min ago</p>
        </div>
      </div>
    </div>
  );
};

export default SocialProofToast;
